
import Vue from "vue";

import ImageSizePicker, {SupportedFormat} from "./image-size-picker.vue";

export const defaultReactNativeOutputFormatOptions: SupportedFormat[] = [
  { key: 'auto', name: "Auto", description: "Auto - png or jpg" },
  { key: 'png', name: "PNG", description: "PNG" },
  { key: 'jpg', name: "JPEG", description: "JPEG" },
];

export default Vue.extend({
  name: "react-native-image-size-picker",
  components: { ImageSizePicker },
  props: {
    sizes: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
  data() {
    return {
      outputFormatOptions: defaultReactNativeOutputFormatOptions
    };
  }
})
